module.exports = __webpack_public_path__ + "img/operate6.1a6c1295.png";